module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"add-media":"Importar mídias","title":"Álbum vazio","description":"Não há fotos ou vídeos ainda.","description-add-media":"@:description Adicione mídias arrastando-as aqui ou clicando no menu acima.","add-to-selection":"Salvar seleção...","album-not-found":"Álbum não encontrado"}}')
  delete Component.options._Ctor
}
